'use client';

import { checkIsAdminRole, useSession } from '@repo/auth';
import { ShimmerButton, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@repo/ui';
import { useTranslations } from 'next-intl';
import type * as React from 'react';
import { Link } from './link';

export function NavbarSystemLink(): React.ReactNode {
  const t = useTranslations('nav');
  const { data: sessionData, isPending } = useSession();
  const isAdmin = checkIsAdminRole({ role: sessionData?.user?.role });

  if (isPending || !isAdmin) {
    return null;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Link
            href="/sys"
            className="flex items-center bg-accent px-4 py-3 text-base font-medium text-foreground data-hover:bg-accent/70"
          >
            {t('system')}
          </Link>
        </TooltipTrigger>
        <TooltipContent>{t('shortcutSystem')}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export function NavbarAccountButton(): React.ReactNode {
  const t = useTranslations('nav');
  const { data: sessionData, isPending } = useSession();
  const isLoggedIn = Boolean(sessionData?.session);

  const href = isPending ? '/login' : isLoggedIn ? '/my' : '/login';
  const label = isLoggedIn ? t('myAccount') : t('logIn');
  const tooltip = isLoggedIn ? t('shortcutAccount') : t('shortcutLogin');

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Link href={href} className="ms-2 inline-block">
            <ShimmerButton
              shimmerColor="#ffffff"
              background="rgb(10, 10, 10)"
              borderRadius="9999px"
              shimmerDuration="3s"
              className="px-5 py-2 text-base font-medium [&>div:first-child]:[direction:ltr]"
            >
              <span className="relative z-10 whitespace-pre text-white">{label}</span>
            </ShimmerButton>
          </Link>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
